import { SxProps, Theme } from '@mui/material/styles';

export const walletCardSx: SxProps<Theme> = {
  width: '446px',
  height: 'auto',
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  p: '16px 14px',
  backgroundColor: '#1E1F25',
  borderRadius: '14px',
  border: '1px solid rgba(255,255,255,0.1)',
  boxSizing: 'border-box',
};

export const walletInnerFrameSx: SxProps<Theme> = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  boxSizing: 'border-box',
};

export const rowSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
};

export const topRowSx: SxProps<Theme> = {
  ...rowSx,
  width: '100%',
  height: 'auto',
  gap: '10px',
};

export const iconBoxSx: SxProps<Theme> = {
  width: '40px',
  height: '40px',

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  borderRadius: '8px',
  backgroundColor: 'rgba(153,168,255,0.1)',
};

export const titleRowSx: SxProps<Theme> = {
  ...rowSx,
  gap: 1,
  '@media (max-width: 767px)': {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 0,
  },
};

export const infoSectionSx: SxProps<Theme> = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '1px',
  boxSizing: 'border-box',
};

export const infoLineSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  width: '100%',
  gap: '4px',
};

export const infoPairSx: SxProps<Theme> = {
  ...rowSx,
  gap: 1,
  '@media (max-width: 767px)': {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 0,
  },
};

export const bottomRowSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  boxSizing: 'border-box',
  gap: '8px',
};

export const primaryTextSx: SxProps<Theme> = {
  fontWeight: 400,
  fontSize: '17px',
  lineHeight: '120%',
  letterSpacing: '-0.02em',
  color: '#CCD4FF',
};

export const mutedTextSx: SxProps<Theme> = {
  fontWeight: 400,
  fontSize: '10px',
  lineHeight: '120%',
  letterSpacing: '-0.02em',
  color: '#8F8F8F',
  flexGrow: 1,
  minWidth: 0,
  maxWidth: 'calc(100% - 80px)',
  whiteSpace: 'normal',
  wordBreak: 'break-word',
};

export const bottomButtonSx: SxProps<Theme> = {
  height: '24px',
  borderRadius: '6.68px',
  backgroundColor: '#354EEF',
  fontSize: '12px',
  flexShrink: 0,
  whiteSpace: 'nowrap',
  minWidth: 'fit-content',
  width: 'auto',
  px: '8px',
  py: 0,
  lineHeight: 1,
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#2a3fd4',
  },
};

export const infoLabelSx: SxProps<Theme> = {
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '120%',
  letterSpacing: '-0.02em',
  color: '#CCD4FF',
};

export const infoValueSx: SxProps<Theme> = {
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '120%',
  letterSpacing: '-0.02em',
  color: '#FFFFFF',
};